var $ = jQuery.noConflict();
if ($( window ).width() >= 1200)
{
    $( ".parent-sub").hover(function(e) {
        if($(this).hasClass('menu-active')){
            $('.parent-sub').removeClass('menu-active')
        }else{
            $('.parent-sub').removeClass('menu-active')
            $('.show-sub-menu').removeClass('show-sub-menu');
            $(this).addClass('menu-active')
        }
        $(this).find('.sub-menu').toggleClass('show-sub-menu');
        $(this).find('.sub-sub-menu').removeClass('sub-active');
    });
}else{
    // Mobile
    $( ".parent-sub").hover(function(e) {
        if($(this).hasClass('menu-active')){
            $('.parent-sub').removeClass('menu-active')
        }else{
            $('.parent-sub').removeClass('menu-active')
            $('.show-sub-menu').removeClass('show-sub-menu');
            $(this).addClass('menu-active');
        }
        $(this).find('.sub-menu').toggleClass('show-sub-menu');
        $(this).find('.sub-sub-menu').removeClass('sub-active');

        var position = $(".site-navigation").position().top;
        $(".mobile-show").animate({scrollTop: '0px'}, 'slow');

    });

    $( ".sub-sub-menu").click(function(e){
        e.stopPropagation();
        $(this).toggleClass('sub-active');
    });


}

$('a[href="#"]').on('click', function(e) {
    e.preventDefault();
});

//removes dropdown menu active class when clicking outside of element
$('body').on('click', function(e) {
    var dropdownMenu = $('.show-sub-menu,.parent-sub');
    if(dropdownMenu !== event.target && !dropdownMenu.has(event.target).length){
        $('.parent-sub').removeClass('menu-active');
        $('.sub-menu').removeClass('show-sub-menu');

    }
});


(function($) {
    // Toggle collapse on submenu
    $('#navbarToggle').on('click', function() {
        var primaryNavigation = $('.site-navigation');
        $this = $(this);

        // Dropdown toggle setup
        if(primaryNavigation.hasClass('mobile-show')) {
            primaryNavigation.removeClass('mobile-show');
            $('body').removeClass('no-scroll');
            $this.addClass('collapsed');
            $this.attr('aria-expanded', 'false');

        } else {
            primaryNavigation.addClass('mobile-show');
            $('body').addClass('no-scroll');
            $this.removeClass('collapsed');
            $this.attr('aria-expanded', 'true');
        }
    });
}(jQuery));

$(document).keyup(function(e) {
    if (e.keyCode == 27) { // escape key maps to keycode `27`
        // console.log('esc');
        if($('.sub-menu').hasClass('show-sub-menu')) {
            $('.sub-menu').removeClass('show-sub-menu');
        }
    }
});

function padContent(){
    var headerHeight = $('.site-header').outerHeight();
    if($('.content').hasClass('content_top_margin_none')){
        $('.content').css('padding-top','0px');
    }else{
        $('.content').css('padding-top',headerHeight);
    }
}

function errorPage(){
    if($('body').hasClass('error404')){
         $('.title_subtitle_holder').css('padding-top','0px');
    }
}

// Add padding top to site main to adjust fixed header height
$(window).on('load resize', function () {
    resizeFunction();
    padContent();
    errorPage();
});

function resizeFunction() {
    if ($( window ).width() >= 1200){
        $(".has_slider").css('padding-top', '');
        let padHeader = $('.site-header').outerHeight() + 'px';
        // console.log(padHeader);
        $(".has_slider").css('padding-top', padHeader);
    }else{
        $(".content_inner").css('margin-top', '');
        let padHeader = $('.header-flex').outerHeight() + 'px';
        console.log(padHeader);
        $(".content_inner").css('margin-top', padHeader);
    }
}

$()